import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
// import CheckBox from '~/componentes/CustomForm/Check/styles/CheckBox';

import { Container, SecaoTicket, ItemTicket, ToggleSwitch } from './styles';
// import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
// import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
// import Acoordion from '~/componentes/Acoordion';
// import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';
import IconRestaurar from '~/assets/icones/IconModalAcessoRefresh.svg';
import ShowLoading from '~/utils/ShowLoading';

function CreateContent({ mountedData }) {
  const [totalHora, setTotalHora] = useState('00:00');
  const [totalPosHorario, setTotalPosHorario] = useState('00:00');
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);
  const [cliente, setCliente] = useState({});
  const [projeto, setProjeto] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [dateInputValue, setDateInputValue] = useState(new Date().toISOString().split('T')[0]);
  const [tipo, setTipo] = useState('P');

  useEffect(() => {
    if (tipo !== 'S') {
      setTotalHora('00:00');
      setTotalPosHorario('00:00');
    }
  }, [tipo]);

  useEffect(() => {
    if (tipo == 'S') {
      ShowLoading(
        () => {
          return api.get('/signed/empresa/suporte/ordensservicos/tickets', {
            params: { dataEmissao: selectedDate },
          });
        },
        { successModal: false, errorModal: true },
      ).then(response => {
        let tickets = [];

        if (!response || !response.data || response?.data?.length === 0) {
          setTickets(null);
          return;
        }

        for (const item of response?.data ?? []) {
          tickets.push({
            ...item,
            tipo: 'A',
            check: false,
            excluido: false,
            posHorario: false,
          });
        }

        setTickets(tickets);
      });
    } else {
      api
        .get('/signed/empresa/suporte/ordemservico/clientes', {
          params: { ativo: 1, dataEmissao: selectedDate },
        })
        .then(response => setClientes(response.data));
      api
        .get('/signed/empresa/suporte/ordemservico/projetos', {
          params: { ativo: 1, idCliente: cliente?.id ? cliente?.id : 0, dataEmissao: selectedDate },
        })
        .then(response => setProjetos(response.data));
    }

    let listaHora = [
      {
        id: 1,
        titulo: 'º Horário',
        idProjetoAtividade: 0,
        horaInicial: '00:00',
        horaFinal: '08:00',
      },
    ];
    setHorarios(listaHora);
    setOrdemServicoAtividades([]);
  }, [tipo, cliente, projeto, selectedDate]);

  useEffect(() => {
    let lista = [];
    if (projeto?.atividades) {
      for (let item of projeto.atividades) {
        lista.push({ check: false, ...item });
      }
    }
    setAtividades(lista);
  }, [projeto]);

  useEffect(() => {
    let lista = [];
    if (projeto?.atividades) {
      for (let item of projeto.atividades) {
        const indexFind = ordemServicoAtividades?.findIndex(e => e?.id == item?.id);

        lista.push({ check: indexFind > -1 ? true : false, ...item });
      }
    }
    setAtividades(lista);

    if (ordemServicoAtividades?.length > 0) {
      let listaHor = [];
      for (const itemAtivo of horarios) {
        listaHor.push({ ...itemAtivo, idProjetoAtividade: ordemServicoAtividades[0]?.id });
      }
      setHorarios(listaHor);
    }
  }, [ordemServicoAtividades]);

  const calcularMinutosEntreTempo = (horaInicial, horaFinal) => {
    if (!horaInicial || !horaFinal) return 0;

    const [horaIni, minIni] = horaInicial.split(':').map(Number);
    const [horaFim, minFim] = horaFinal.split(':').map(Number);

    const totalMinutosIni = horaIni * 60 + minIni;
    const totalMinutosFim = horaFim * 60 + minFim;

    return Math.max(0, totalMinutosFim - totalMinutosIni);
  };

  const getPrimeiraHoraInicial = item =>
    (item?.horarios || []).reduce((menor, horario) => {
      if (!horario?.horaInicial) return menor;
      return !menor || horario.horaInicial < menor ? horario.horaInicial : menor;
    }, null) || '';

  useEffect(() => {
    if (tipo === 'S' && tickets?.length > 0) {
      let totalHoraMinutos = 0;
      let totalPosHoraMinutos = 0;

      for (const ticket of tickets) {
        if (ticket?.excluido) continue;

        let minutosTicket = 0;
        if (ticket.tipo === 'A') {
          for (const itemHorario of ticket?.horarios ?? []) {
            minutosTicket += parseFloat(itemHorario?.totalHoraMinutos || 0);
          }
        } else if (ticket.tipo === 'M') {
          minutosTicket += parseFloat(ticket?.totalHoraMinutos || 0);
        }

        totalHoraMinutos += minutosTicket;
        if (ticket?.posHorario) {
          totalPosHoraMinutos += minutosTicket;
        }
      }

      let horas = parseInt(totalHoraMinutos / 60);
      let minutos = totalHoraMinutos % 60;
      const totalFormatado = ('00' + horas).slice(-2) + ':' + ('00' + minutos).slice(-2);

      setTotalHora(totalFormatado);

      let horasPos = parseInt(totalPosHoraMinutos / 60);
      let minutosPos = totalPosHoraMinutos % 60;
      setTotalPosHorario(('00' + horasPos).slice(-2) + ':' + ('00' + minutosPos).slice(-2));
    }
  }, [tickets, tipo]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          dataEmissao: selectedDate,
          horarios,
          atividades: ordemServicoAtividades,
          tickets,
          tipo,
        };

        let response = await api.post('/signed/empresa/suporte/ordemservico', thisData);
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Não foi possível salvar a Ordem de Serviço. Nenhuma informação foi salva. Entre em contato com o suporte técnico.`,
        },
        message: `Tem certeza que deseja cadastrar essa Ordem de Serviço?`,
        successModal: `Ordem de Serviço cadastrada com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>

        {tipo == 'S' ? (
          <div>
            <div className="row">
              <Label title="Tipo" className="col s12 m6 l2">
                <Select
                  isString
                  list={{
                    list: [
                      { id: 'S', titulo: 'Suporte' },
                      { id: 'P', titulo: 'Projeto' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="tipo"
                  defaultValue={mountedData?.tipo}
                  onChange={e => {
                    const v = e.currentTarget.value || 'S';
                    setTipo(v);
                  }}
                />
              </Label>
              <Label title="Data *" className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataEmissao"
                  required="true"
                  value={dateInputValue}
                  onChange={e => {
                    setDateInputValue(e.currentTarget.value);
                  }}
                  onBlur={e => {
                    setSelectedDate(e.currentTarget.value);
                  }}
                />
              </Label>
              <Label title="Título *" className="col s12 m8 l4">
                <Input name="titulo" required="true" />
              </Label>
              <Label title="Total Pós-Horário" className="col s12 m4 l2">
                <Input name="totalPosHorario" disabled="true" value={totalPosHorario} />
              </Label>
              <Label title="Total OS *" className="col s12 m4 l2">
                <Input name="totalOS" readonly="true" required="true" value={totalHora} />
              </Label>
            </div>

            <div className="row">
              <div className="content-top">
                <p className="title_p">Atividades *</p>
                <div
                  className="novo-horario"
                  onClick={() => {
                    const existingManual = tickets.find(e => e?.tipo === 'M');
                    if (!existingManual) {
                      const novaAtividadeSRP = {
                        tipo: 'M',
                        idTicket: 0,
                        categoria: '-',
                        urgencia: '-',
                        titulo: 'Atividade SRP',
                        cliente: 'ERPWorks',
                        check: true,
                        idMovidesk: '-',
                        idMovideskAction: '-',
                        description: '',
                        htmlDescription: '',
                        totalHora: '00:00',
                        totalHoraMinutos: 0,
                        excluido: false,
                        posHorario: false,
                        horarios: [
                          {
                            idMovideskTime: 0,
                            horaInicial: '00:00',
                            horaFinal: '00:00',
                            horaTrabalhada: '00:00',
                            totalHoraMinutos: 0,
                          },
                        ],
                      };

                      setTickets([...tickets, novaAtividadeSRP]);
                    }
                  }}
                >
                  <p className="adiciona-horario">Adicionar</p>
                </div>
              </div>
              <div className="col s12 m12 l12">
                <ItemTicket item={false}>
                  <div className="col s1 m1 l1">
                    <p className="text-col">Id Ticket</p>
                  </div>
                  <div className="col s1 m1 l1">
                    <p className="text-col">Id Interacao</p>
                  </div>
                  <div className="col s3 m3 l3">
                    <p className="text-col">Cliente</p>
                  </div>
                  <div className="col s5 m5 l5">
                    <p className="text-col">Titulo Ticket</p>
                  </div>
                  <div className="col s1 m1 l1">
                    <p className="text-col">Tot. Hora</p>
                  </div>
                  <div className="col s2 m2 l2">
                    <p className="text-col" style={{ textAlign: 'right', width: '100%' }}>
                      SRP Autorizado
                    </p>
                  </div>
                </ItemTicket>
                <div className="content-atividade">
                  {tickets ? (
                    [...tickets]
                      .sort((a, b) => {
                        if ((a?.tipo === 'M') !== (b?.tipo === 'M')) {
                          return a?.tipo === 'M' ? -1 : 1;
                        }
                        return getPrimeiraHoraInicial(a).localeCompare(getPrimeiraHoraInicial(b));
                      })
                      .map(item => (
                        <SecaoTicket key={item?.id}>
                          <ItemTicket
                            item={true}
                            excluido={item?.excluido}
                            onClick={() => {
                              if (item?.tipo == 'M' || item?.excluido) {
                                return;
                              }
                              let lista = [];
                              for (let itemTicket of tickets) {
                                if (
                                  item?.idMoviDesk == itemTicket?.idMoviDesk &&
                                  item?.idMovideskAction == itemTicket?.idMovideskAction
                                ) {
                                  lista.push({ ...itemTicket, check: !itemTicket?.check });
                                } else {
                                  lista.push({ ...itemTicket });
                                }
                              }
                              setTickets(lista);
                            }}
                          >
                            <div className="col s1 m1 l1">
                              <p className="text-col">#{item?.idMoviDesk}</p>
                            </div>
                            <div className="col s1 m1 l1">
                              <p className="text-col">{item?.idMovideskAction}</p>
                            </div>
                            <div className="col s3 m3 l3">
                              <p className="text-col">{item?.cliente}</p>
                            </div>
                            <div className="col s5 m5 l5">
                              <p className="text-col">{item?.titulo}</p>
                            </div>
                            <div className="col s1 m1 l1">
                              <p className="text-col">{item?.totalHora}</p>
                            </div>
                            <div className="col s2 m2 l2 col-acoes-final">
                              {item?.tipo !== 'M' && (
                                <ToggleSwitch onClick={e => e.stopPropagation()}>
                                  <input
                                    type="checkbox"
                                    checked={!!item?.posHorario}
                                    disabled={item?.excluido}
                                    onChange={e => {
                                      const checked = e.currentTarget.checked;
                                      setTickets(
                                        tickets.map(itemTicket =>
                                          itemTicket === item
                                            ? { ...itemTicket, posHorario: checked }
                                            : itemTicket,
                                        ),
                                      );
                                    }}
                                  />
                                  <span className="slider" />
                                </ToggleSwitch>
                              )}
                              {/* Botão de excluir/restaurar OS removido da tela a pedido.
                              {item?.excluido ? (
                                <img
                                  src={IconRestaurar}
                                  alt="restaurar"
                                  onClick={e => {
                                    e.stopPropagation();
                                    setTickets(
                                      tickets.map(itemTicket =>
                                        itemTicket === item
                                          ? { ...itemTicket, excluido: false }
                                          : itemTicket,
                                      ),
                                    );
                                  }}
                                />
                              ) : (
                                <img
                                  src={IconLixeira}
                                  alt="lixeira"
                                  onClick={e => {
                                    e.stopPropagation();
                                    if (item?.tipo === 'M') {
                                      setTickets(tickets.filter(itemTicket => itemTicket !== item));
                                      return;
                                    }
                                    setTickets(
                                      tickets.map(itemTicket =>
                                        itemTicket === item
                                          ? { ...itemTicket, excluido: true }
                                          : itemTicket,
                                      ),
                                    );
                                  }}
                                />
                              )}
                              */}
                            </div>
                          </ItemTicket>
                          {item?.check == true && item?.tipo == 'A' && !item?.excluido && (
                            <div className="atv-content-body">
                              <div className="col s12 m7 l7">
                                <p
                                  className={
                                    item?.htmlDescription ? 'item-desc' : 'item-desc no-html'
                                  }
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.htmlDescription
                                        ? item?.htmlDescription
                                        : item?.description,
                                    }}
                                  ></div>
                                </p>
                              </div>
                              <div className="col s12 m5 l5">
                                {[...(item?.horarios || [])]
                                  .sort((a, b) =>
                                    (a?.horaInicial || '').localeCompare(b?.horaInicial || ''),
                                  )
                                  .map((itemHorario, index) => (
                                    <div className="item-horario" key={index}>
                                      <div className="col s12 m8 l11">
                                        <Label title="Hora Inicial" className="col s6 m6 l6">
                                          <Input
                                            type="time"
                                            name="horaInicial"
                                            disabled="true"
                                            value={itemHorario?.horaInicial}
                                          />
                                        </Label>
                                        <Label title="Hora Final" className="col s6 m6 l6">
                                          <Input
                                            type="time"
                                            name="horaFinal"
                                            disabled="true"
                                            value={itemHorario?.horaFinal}
                                          />
                                        </Label>
                                      </div>
                                      {/* <div className="col s12 m4 l1">
                                      <img src={IconLixeira} alt="lixeira" />
                                    </div> */}
                                    </div>
                                  ))}
                              </div>
                            </div>
                          )}
                          {item?.check == true && item?.tipo == 'M' && !item?.excluido && (
                            <div className="atv-content-body">
                              <div className="col s12 m7 l7">
                                <Label title="Descrição *" className="col s12 m12 l12">
                                  <TextArea
                                    name="descricao"
                                    required="true"
                                    defaultValue={item?.descricao}
                                    onChange={e => {
                                      const v = e.currentTarget.value || '';

                                      let lista = [];
                                      for (const itemTicket of tickets) {
                                        if (
                                          item?.idMoviDesk == itemTicket?.idMoviDesk &&
                                          item?.idMovideskAction == itemTicket?.idMovideskAction
                                        ) {
                                          lista.push({ ...itemTicket, description: v });
                                        } else {
                                          lista.push(itemTicket);
                                        }
                                      }

                                      setTickets(lista);
                                    }}
                                  />
                                </Label>
                              </div>
                              <div className="col s12 m5 l5">
                                <div className="content-top">
                                  <p className="title_p">Horarios *</p>
                                  <div
                                    className="novo-horario"
                                    onClick={() => {
                                      let lista = [];
                                      for (const itemTicket of tickets) {
                                        if (
                                          item?.idMoviDesk == itemTicket?.idMoviDesk &&
                                          item?.idMovideskAction == itemTicket?.idMovideskAction
                                        ) {
                                          let listaHorarios = [];
                                          let count = 0;
                                          for (let itemHor of itemTicket?.horarios ?? []) {
                                            listaHorarios.push({ ...itemHor, id: count });

                                            count++;
                                          }

                                          listaHorarios.push({
                                            idMovideskTime: count,
                                            horaInicial: '00:00',
                                            horaFinal: '00:00',
                                            horaTrabalhada: '00:00',
                                            totalHoraMinutos: 0,
                                          });

                                          lista.push({ ...itemTicket, horarios: listaHorarios });
                                        } else {
                                          lista.push(itemTicket);
                                        }
                                      }

                                      setTickets(lista);
                                    }}
                                  >
                                    <p className="adiciona-horario">Adicionar</p>
                                  </div>
                                </div>
                                {[...(item?.horarios || [])]
                                  .sort((a, b) =>
                                    (a?.horaInicial || '').localeCompare(b?.horaInicial || ''),
                                  )
                                  .map((itemHorario, index) => (
                                    <div className="item-horario" key={index}>
                                      <div className="col s12 m8 l11">
                                        <Label title="Hora Inicial" className="col s6 m6 l6">
                                          <Input
                                            type="time"
                                            name="horaInicial"
                                            required="true"
                                            value={itemHorario?.horaInicial}
                                            onChange={e => {
                                              const v = e.currentTarget.value || '';

                                              let lista = [];
                                              for (const itemTicket of tickets) {
                                                if (
                                                  item?.idMoviDesk == itemTicket?.idMoviDesk &&
                                                  item?.idMovideskAction ==
                                                    itemTicket?.idMovideskAction
                                                ) {
                                                  let listaHorarios = [];
                                                  for (let itemHor of itemTicket?.horarios ?? []) {
                                                    if (
                                                      itemHorario?.idMovideskTime ==
                                                      itemHor?.idMovideskTime
                                                    ) {
                                                      const novoHorario = {
                                                        ...itemHor,
                                                        horaInicial: v,
                                                      };
                                                      if (
                                                        itemTicket.tipo === 'M' &&
                                                        novoHorario.horaFinal
                                                      ) {
                                                        const minutos = calcularMinutosEntreTempo(
                                                          v,
                                                          novoHorario.horaFinal,
                                                        );
                                                        novoHorario.totalHoraMinutos = minutos;
                                                        novoHorario.horaTrabalhada =
                                                          ('00' + parseInt(minutos / 60)).slice(
                                                            -2,
                                                          ) +
                                                          ':' +
                                                          ('00' + (minutos % 60)).slice(-2);
                                                      }
                                                      listaHorarios.push(novoHorario);
                                                    } else {
                                                      listaHorarios.push(itemHor);
                                                    }
                                                  }

                                                  let ticketAtualizado = {
                                                    ...itemTicket,
                                                    horarios: listaHorarios,
                                                  };
                                                  if (itemTicket.tipo === 'M') {
                                                    const totalMinutos = listaHorarios.reduce(
                                                      (acc, horario) =>
                                                        acc + (horario.totalHoraMinutos || 0),
                                                      0,
                                                    );
                                                    ticketAtualizado.totalHoraMinutos =
                                                      totalMinutos;
                                                    ticketAtualizado.totalHora =
                                                      ('00' + parseInt(totalMinutos / 60)).slice(
                                                        -2,
                                                      ) +
                                                      ':' +
                                                      ('00' + (totalMinutos % 60)).slice(-2);
                                                  }

                                                  lista.push(ticketAtualizado);
                                                } else {
                                                  lista.push(itemTicket);
                                                }
                                              }

                                              setTickets(lista);
                                            }}
                                          />
                                        </Label>
                                        <Label title="Hora Final" className="col s6 m6 l6">
                                          <Input
                                            type="time"
                                            name="horaFinal"
                                            required="true"
                                            value={itemHorario?.horaFinal}
                                            onChange={e => {
                                              const v = e.currentTarget.value || '';

                                              let lista = [];
                                              for (const itemTicket of tickets) {
                                                if (
                                                  item?.idMoviDesk == itemTicket?.idMoviDesk &&
                                                  item?.idMovideskAction ==
                                                    itemTicket?.idMovideskAction
                                                ) {
                                                  let listaHorarios = [];
                                                  for (let itemHor of itemTicket?.horarios ?? []) {
                                                    if (
                                                      itemHorario?.idMovideskTime ==
                                                      itemHor?.idMovideskTime
                                                    ) {
                                                      const novoHorario = {
                                                        ...itemHor,
                                                        horaFinal: v,
                                                      };
                                                      if (
                                                        itemTicket.tipo === 'M' &&
                                                        novoHorario.horaInicial
                                                      ) {
                                                        const minutos = calcularMinutosEntreTempo(
                                                          novoHorario.horaInicial,
                                                          v,
                                                        );
                                                        novoHorario.totalHoraMinutos = minutos;
                                                        novoHorario.horaTrabalhada =
                                                          ('00' + parseInt(minutos / 60)).slice(
                                                            -2,
                                                          ) +
                                                          ':' +
                                                          ('00' + (minutos % 60)).slice(-2);
                                                      }
                                                      listaHorarios.push(novoHorario);
                                                    } else {
                                                      listaHorarios.push(itemHor);
                                                    }
                                                  }

                                                  let ticketAtualizado = {
                                                    ...itemTicket,
                                                    horarios: listaHorarios,
                                                  };
                                                  if (itemTicket.tipo === 'M') {
                                                    const totalMinutos = listaHorarios.reduce(
                                                      (acc, horario) =>
                                                        acc + (horario.totalHoraMinutos || 0),
                                                      0,
                                                    );
                                                    ticketAtualizado.totalHoraMinutos =
                                                      totalMinutos;
                                                    ticketAtualizado.totalHora =
                                                      ('00' + parseInt(totalMinutos / 60)).slice(
                                                        -2,
                                                      ) +
                                                      ':' +
                                                      ('00' + (totalMinutos % 60)).slice(-2);
                                                  }

                                                  lista.push(ticketAtualizado);
                                                } else {
                                                  lista.push(itemTicket);
                                                }
                                              }

                                              setTickets(lista);
                                            }}
                                          />
                                        </Label>
                                      </div>

                                      <div className="col s12 m4 l1" style={{ cursor: 'pointer' }}>
                                        <img
                                          src={IconLixeira}
                                          alt="lixeira"
                                          onClick={() => {
                                            if (item?.horarios?.length <= 1) {
                                              return;
                                            }

                                            let lista = [];
                                            for (const itemTicket of tickets) {
                                              if (
                                                item?.idMoviDesk == itemTicket?.idMoviDesk &&
                                                item?.idMovideskAction ==
                                                  itemTicket?.idMovideskAction
                                              ) {
                                                let listaHorarios = [];
                                                for (let itemHor of itemTicket?.horarios ?? []) {
                                                  if (
                                                    itemHorario?.idMovideskTime !=
                                                    itemHor?.idMovideskTime
                                                  ) {
                                                    listaHorarios.push(itemHor);
                                                  }
                                                }

                                                console.log(listaHorarios);

                                                lista.push({
                                                  ...itemTicket,
                                                  horarios: listaHorarios,
                                                });
                                              } else {
                                                lista.push(itemTicket);
                                              }
                                            }

                                            setTickets(lista);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          )}
                        </SecaoTicket>
                      ))
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '200px',
                      }}
                    >
                      <p>Nenhum ticket encontrado para essa data.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className={tipo == 'S' ? 'col s8 m8 l12' : 'col s8 m8 l8'}>
              <div className="row">
                <Label title="Tipo" className="col s2 m2 l3">
                  <Select
                    isString
                    list={{
                      list: [
                        { id: 'S', titulo: 'Suporte' },
                        { id: 'P', titulo: 'Projeto' },
                      ],
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="tipo"
                    defaultValue={tipo}
                    onChange={e => {
                      const v = e.currentTarget.value || 'S';
                      setTipo(v);
                    }}
                  />
                </Label>
                <Label title="Data *" className="col s6 m4 l3">
                  <Input
                    type="date"
                    name="dataEmissao"
                    required="true"
                    value={dateInputValue}
                    onChange={e => {
                      setDateInputValue(e.currentTarget.value);
                    }}
                    onBlur={e => {
                      setSelectedDate(e.currentTarget.value);
                    }}
                  />
                </Label>
                <Label title="Título *" className="col s6 m8 l6">
                  <Input name="titulo" required="true" />
                </Label>
              </div>
              <div className="row">
                <Label title="Cliente *" className="col s4 m4 l4">
                  <Select
                    required="true"
                    isString
                    list={{
                      list: clientes,
                      value: 'id',
                      label: 'nomeFantasia',
                    }}
                    name="idCliente"
                    firstOption
                    onChange={e => {
                      const v = e.currentTarget.value || 0;
                      const cliente = clientes?.find(e => e?.id == parseInt(v));
                      setCliente(cliente || {});
                    }}
                  />
                </Label>
                <Label title="Projeto *" className="col s4 m4 l4">
                  <Select
                    required="true"
                    isString
                    list={{
                      list: projetos,
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="idProjeto"
                    firstOption
                    onChange={e => {
                      const v = e.currentTarget.value || 0;
                      const projeto = projetos?.find(e => e?.id == parseInt(v));
                      setProjeto(projeto || {});
                    }}
                  />
                </Label>
                <Label title="Desconto" className="col s2 m2 l2">
                  <Select
                    isString
                    list={{
                      list: [
                        { id: '00:00', titulo: '00:00' },
                        { id: '00:15', titulo: '00:15' },
                        { id: '00:30', titulo: '00:30' },
                        { id: '00:45', titulo: '00:45' },
                        { id: '01:00', titulo: '01:00' },
                        { id: '01:15', titulo: '01:15' },
                        { id: '01:30', titulo: '01:30' },
                        { id: '01:45', titulo: '01:45' },
                        { id: '02:00', titulo: '02:00' },
                        { id: '02:15', titulo: '02:15' },
                        { id: '02:30', titulo: '02:30' },
                        { id: '02:45', titulo: '02:45' },
                        { id: '03:00', titulo: '03:00' },
                        { id: '03:15', titulo: '03:15' },
                        { id: '03:30', titulo: '03:30' },
                        { id: '03:45', titulo: '03:45' },
                        { id: '04:00', titulo: '04:00' },
                        { id: '04:15', titulo: '04:15' },
                        { id: '04:30', titulo: '04:30' },
                        { id: '04:45', titulo: '04:45' },
                        { id: '05:00', titulo: '05:00' },
                        { id: '05:15', titulo: '05:15' },
                        { id: '05:30', titulo: '05:30' },
                        { id: '05:45', titulo: '05:45' },
                        { id: '06:00', titulo: '06:00' },
                        { id: '06:15', titulo: '06:15' },
                        { id: '06:30', titulo: '06:30' },
                        { id: '06:45', titulo: '06:45' },
                        { id: '07:00', titulo: '07:00' },
                        { id: '07:15', titulo: '07:15' },
                        { id: '07:30', titulo: '07:30' },
                        { id: '07:45', titulo: '07:45' },
                        { id: '08:00', titulo: '08:00' },
                        { id: '08:15', titulo: '08:15' },
                        { id: '08:30', titulo: '08:30' },
                        { id: '08:45', titulo: '08:45' },
                        { id: '09:00', titulo: '09:00' },
                        { id: '09:15', titulo: '09:15' },
                        { id: '09:30', titulo: '09:30' },
                        { id: '09:45', titulo: '09:45' },
                        { id: '10:00', titulo: '10:00' },
                        { id: '10:15', titulo: '10:15' },
                        { id: '10:30', titulo: '10:30' },
                        { id: '10:45', titulo: '10:45' },
                        { id: '11:00', titulo: '11:00' },
                        { id: '11:15', titulo: '11:15' },
                        { id: '11:30', titulo: '11:30' },
                        { id: '11:45', titulo: '11:45' },
                        { id: '12:00', titulo: '12:00' },
                        { id: '12:15', titulo: '12:15' },
                        { id: '12:30', titulo: '12:30' },
                        { id: '12:45', titulo: '12:45' },
                        { id: '13:00', titulo: '13:00' },
                        { id: '13:15', titulo: '13:15' },
                        { id: '13:30', titulo: '13:30' },
                        { id: '13:45', titulo: '13:45' },
                        { id: '14:00', titulo: '14:00' },
                        { id: '14:15', titulo: '14:15' },
                        { id: '14:30', titulo: '14:30' },
                        { id: '14:45', titulo: '14:45' },
                        { id: '15:00', titulo: '15:00' },
                        { id: '15:15', titulo: '15:15' },
                        { id: '15:30', titulo: '15:30' },
                        { id: '15:45', titulo: '15:45' },
                        { id: '16:00', titulo: '16:00' },
                        { id: '16:15', titulo: '16:15' },
                        { id: '16:30', titulo: '16:30' },
                        { id: '16:45', titulo: '16:45' },
                        { id: '17:00', titulo: '17:00' },
                        { id: '17:15', titulo: '17:15' },
                        { id: '17:30', titulo: '17:30' },
                        { id: '17:45', titulo: '17:45' },
                        { id: '18:00', titulo: '18:00' },
                        { id: '18:15', titulo: '18:15' },
                        { id: '18:30', titulo: '18:30' },
                        { id: '18:45', titulo: '18:45' },
                        { id: '19:00', titulo: '19:00' },
                        { id: '19:15', titulo: '19:15' },
                        { id: '19:30', titulo: '19:30' },
                        { id: '19:45', titulo: '19:45' },
                        { id: '20:00', titulo: '20:00' },
                        { id: '20:15', titulo: '20:15' },
                        { id: '20:30', titulo: '20:30' },
                        { id: '20:45', titulo: '20:45' },
                        { id: '21:00', titulo: '21:00' },
                        { id: '21:15', titulo: '21:15' },
                        { id: '21:30', titulo: '21:30' },
                        { id: '21:45', titulo: '18:45' },
                        { id: '22:00', titulo: '22:00' },
                        { id: '22:15', titulo: '22:15' },
                        { id: '22:30', titulo: '22:30' },
                        { id: '22:45', titulo: '22:45' },
                        { id: '23:00', titulo: '23:00' },
                        { id: '23:15', titulo: '23:15' },
                        { id: '23:30', titulo: '23:30' },
                        { id: '23:45', titulo: '23:45' },
                      ],
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="horaDesconto"
                    defaultValue="00:00"
                  />
                </Label>
                <Label title="Translado" className="col s2 m2 l2">
                  <Select
                    isString
                    list={{
                      list: [
                        { id: '00:00', titulo: '00:00' },
                        { id: '00:15', titulo: '00:15' },
                        { id: '00:30', titulo: '00:30' },
                        { id: '00:45', titulo: '00:45' },
                        { id: '01:00', titulo: '01:00' },
                        { id: '01:15', titulo: '01:15' },
                        { id: '01:30', titulo: '01:30' },
                        { id: '01:45', titulo: '01:45' },
                        { id: '02:00', titulo: '02:00' },
                        { id: '02:15', titulo: '02:15' },
                        { id: '02:30', titulo: '02:30' },
                        { id: '02:45', titulo: '02:45' },
                        { id: '03:00', titulo: '03:00' },
                        { id: '03:15', titulo: '03:15' },
                        { id: '03:30', titulo: '03:30' },
                        { id: '03:45', titulo: '03:45' },
                        { id: '04:00', titulo: '04:00' },
                        { id: '04:15', titulo: '04:15' },
                        { id: '04:30', titulo: '04:30' },
                        { id: '04:45', titulo: '04:45' },
                        { id: '05:00', titulo: '05:00' },
                        { id: '05:15', titulo: '05:15' },
                        { id: '05:30', titulo: '05:30' },
                        { id: '05:45', titulo: '05:45' },
                        { id: '06:00', titulo: '06:00' },
                        { id: '06:15', titulo: '06:15' },
                        { id: '06:30', titulo: '06:30' },
                        { id: '06:45', titulo: '06:45' },
                        { id: '07:00', titulo: '07:00' },
                        { id: '07:15', titulo: '07:15' },
                        { id: '07:30', titulo: '07:30' },
                        { id: '07:45', titulo: '07:45' },
                        { id: '08:00', titulo: '08:00' },
                        { id: '08:15', titulo: '08:15' },
                        { id: '08:30', titulo: '08:30' },
                        { id: '08:45', titulo: '08:45' },
                        { id: '09:00', titulo: '09:00' },
                        { id: '09:15', titulo: '09:15' },
                        { id: '09:30', titulo: '09:30' },
                        { id: '09:45', titulo: '09:45' },
                        { id: '10:00', titulo: '10:00' },
                        { id: '10:15', titulo: '10:15' },
                        { id: '10:30', titulo: '10:30' },
                        { id: '10:45', titulo: '10:45' },
                        { id: '11:00', titulo: '11:00' },
                        { id: '11:15', titulo: '11:15' },
                        { id: '11:30', titulo: '11:30' },
                        { id: '11:45', titulo: '11:45' },
                        { id: '12:00', titulo: '12:00' },
                        { id: '12:15', titulo: '12:15' },
                        { id: '12:30', titulo: '12:30' },
                        { id: '12:45', titulo: '12:45' },
                        { id: '13:00', titulo: '13:00' },
                        { id: '13:15', titulo: '13:15' },
                        { id: '13:30', titulo: '13:30' },
                        { id: '13:45', titulo: '13:45' },
                        { id: '14:00', titulo: '14:00' },
                        { id: '14:15', titulo: '14:15' },
                        { id: '14:30', titulo: '14:30' },
                        { id: '14:45', titulo: '14:45' },
                        { id: '15:00', titulo: '15:00' },
                        { id: '15:15', titulo: '15:15' },
                        { id: '15:30', titulo: '15:30' },
                        { id: '15:45', titulo: '15:45' },
                        { id: '16:00', titulo: '16:00' },
                        { id: '16:15', titulo: '16:15' },
                        { id: '16:30', titulo: '16:30' },
                        { id: '16:45', titulo: '16:45' },
                        { id: '17:00', titulo: '17:00' },
                        { id: '17:15', titulo: '17:15' },
                        { id: '17:30', titulo: '17:30' },
                        { id: '17:45', titulo: '17:45' },
                        { id: '18:00', titulo: '18:00' },
                        { id: '18:15', titulo: '18:15' },
                        { id: '18:30', titulo: '18:30' },
                        { id: '18:45', titulo: '18:45' },
                        { id: '19:00', titulo: '19:00' },
                        { id: '19:15', titulo: '19:15' },
                        { id: '19:30', titulo: '19:30' },
                        { id: '19:45', titulo: '19:45' },
                        { id: '20:00', titulo: '20:00' },
                        { id: '20:15', titulo: '20:15' },
                        { id: '20:30', titulo: '20:30' },
                        { id: '20:45', titulo: '20:45' },
                        { id: '21:00', titulo: '21:00' },
                        { id: '21:15', titulo: '21:15' },
                        { id: '21:30', titulo: '21:30' },
                        { id: '21:45', titulo: '18:45' },
                        { id: '22:00', titulo: '22:00' },
                        { id: '22:15', titulo: '22:15' },
                        { id: '22:30', titulo: '22:30' },
                        { id: '22:45', titulo: '22:45' },
                        { id: '23:00', titulo: '23:00' },
                        { id: '23:15', titulo: '23:15' },
                        { id: '23:30', titulo: '23:30' },
                        { id: '23:45', titulo: '23:45' },
                      ],
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="horaTranslado"
                    defaultValue="00:00"
                  />
                </Label>
              </div>
              <div className="row">
                <div className="col s12 m12 l12">
                  <p className="title_p">Atividades *</p>
                  <div className="content-atividade">
                    {tipo == 'P' &&
                      atividades?.map((item, index) => (
                        <div className="atv-content" key={index}>
                          <div className="atv-content-top">
                            <div className="card-titulo">
                              <p className="titulo">
                                {item?.id} - {item?.titulo}
                              </p>
                            </div>
                            {item?.check == true ? (
                              <div
                                className="card-check checked"
                                onClick={() => {
                                  const itemFind = ordemServicoAtividades?.find(
                                    e => e?.id == item?.id,
                                  );
                                  let lista = [];
                                  for (let itemOS of ordemServicoAtividades) {
                                    if (itemFind?.id != itemOS?.id) {
                                      lista.push(itemOS);
                                    }
                                  }
                                  setOrdemServicoAtividades(lista);
                                }}
                              >
                                <span />
                              </div>
                            ) : (
                              <div
                                className="card-check"
                                onClick={() => {
                                  let lista = [];
                                  for (const itemAtivo of ordemServicoAtividades) {
                                    lista.push(itemAtivo);
                                  }

                                  let indexFind = lista.findIndex(e => e?.id == item?.id);
                                  if (indexFind == -1) {
                                    lista.push(item);
                                  }

                                  setOrdemServicoAtividades(lista);
                                }}
                              >
                                <span />
                              </div>
                            )}
                          </div>
                          {item?.check == true && (
                            <div className="atv-content-body">
                              <Label title="Descrição *" className="col s12 m12 l12">
                                <TextArea
                                  name="descricao"
                                  required="true"
                                  defaultValue={item?.descricao}
                                  onChange={e => {
                                    const v = e.currentTarget.value || '';

                                    let lista = [];
                                    for (const itemAtivo of ordemServicoAtividades) {
                                      if (itemAtivo?.id == item?.id) {
                                        lista.push({ ...itemAtivo, descricao: v });
                                      } else {
                                        lista.push(itemAtivo);
                                      }
                                    }

                                    setOrdemServicoAtividades(lista);
                                  }}
                                />
                              </Label>
                            </div>
                          )}
                        </div>
                      ))}
                    {tipo == 'S' &&
                      tickets?.map((item, index) => (
                        <div className="atv-content" key={index}>
                          <div className="atv-content-top">
                            <div className="card-titulo">
                              <p className="titulo">
                                {item?.id} - {item?.subject}
                              </p>
                            </div>
                            {item?.check == true ? (
                              <div
                                className="card-check checked"
                                onClick={() => {
                                  const itemFind = ordemServicoAtividades?.find(
                                    e => e?.id == item?.id,
                                  );
                                  let lista = [];
                                  for (let itemOS of ordemServicoAtividades) {
                                    if (itemFind?.id != itemOS?.id) {
                                      lista.push(itemOS);
                                    }
                                  }
                                  setOrdemServicoAtividades(lista);
                                }}
                              >
                                <span />
                              </div>
                            ) : (
                              <div
                                className="card-check"
                                onClick={() => {
                                  let lista = [];
                                  for (const itemAtivo of ordemServicoAtividades) {
                                    lista.push(itemAtivo);
                                  }

                                  let indexFind = lista.findIndex(e => e?.id == item?.id);
                                  if (indexFind == -1) {
                                    lista.push(item);
                                  }

                                  setOrdemServicoAtividades(lista);
                                }}
                              >
                                <span />
                              </div>
                            )}
                          </div>
                          {item?.check == true && (
                            <div className="atv-content-body">
                              <Label title="Descrição *" className="col s12 m12 l12">
                                <TextArea
                                  name="descricao"
                                  required="true"
                                  defaultValue={item?.descricao}
                                  onChange={e => {
                                    const v = e.currentTarget.value || '';

                                    let lista = [];
                                    for (const itemAtivo of ordemServicoAtividades) {
                                      if (itemAtivo?.id == item?.id) {
                                        lista.push({ ...itemAtivo, descricao: v });
                                      } else {
                                        lista.push(itemAtivo);
                                      }
                                    }

                                    setOrdemServicoAtividades(lista);
                                  }}
                                />
                              </Label>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col s4 m4 l4">
              <p className="title_p">Horários *</p>
              <div className="row-left">
                <div className="col s12 m12 l12">
                  {horarios &&
                    horarios?.map(item => (
                      <div className="content" key={item?.id}>
                        <div className="content-top">
                          <div className="card-cod">
                            <p className="cod">
                              {item?.id} {item?.titulo}
                            </p>
                          </div>
                          <img
                            src={IconLixeira}
                            alt="lixeira"
                            onClick={() => {
                              if (horarios.length > 1) {
                                const itemFind = horarios?.find(d => d?.id == item?.id);
                                let lista = [];
                                for (let itemHor of horarios) {
                                  if (itemFind?.id != itemHor?.id) {
                                    lista.push(itemHor);
                                  }
                                }
                                setHorarios(lista);
                              }
                            }}
                          />
                        </div>
                        <div className="content-body">
                          <Label title="Atividade *" className="col s12 m12 l12">
                            <Select
                              isString
                              list={{
                                list: ordemServicoAtividades,
                                value: 'id',
                                label: 'titulo',
                              }}
                              name="idProjetoAtividade"
                              firstOption
                              onChange={e => {
                                const v = e.currentTarget.value || 0;

                                let lista = [];
                                for (const itemAtivo of horarios) {
                                  if (itemAtivo?.id == item?.id) {
                                    lista.push({ ...itemAtivo, idProjetoAtividade: v });
                                  } else {
                                    lista.push(itemAtivo);
                                  }
                                }

                                setHorarios(lista);
                              }}
                            />
                          </Label>
                          <Label title="Hora Inicial *" className="col s6 m6 l6">
                            <Input
                              type="time"
                              name="horaInicial"
                              required="true"
                              value={item?.horaInicial}
                              onChange={e => {
                                const v = e.currentTarget.value || '00:00';

                                let lista = [];
                                for (const itemAtivo of horarios) {
                                  if (itemAtivo?.id == item?.id) {
                                    lista.push({ ...itemAtivo, horaInicial: v });
                                  } else {
                                    lista.push(itemAtivo);
                                  }
                                }

                                setHorarios(lista);
                              }}
                            />
                          </Label>
                          <Label title="Hora Final *" className="col s6 m6 l6">
                            <Input
                              type="time"
                              name="horaFinal"
                              required="true"
                              value={item?.horaFinal}
                              onChange={e => {
                                const v = e.currentTarget.value || '';

                                let lista = [];
                                for (const itemAtivo of horarios) {
                                  if (itemAtivo?.id == item?.id) {
                                    lista.push({ ...itemAtivo, horaFinal: v });
                                  } else {
                                    lista.push(itemAtivo);
                                  }
                                }

                                setHorarios(lista);
                              }}
                            />
                          </Label>
                        </div>
                      </div>
                    ))}
                </div>
                <div
                  className="novo-horario"
                  onClick={() => {
                    let lista = [];
                    for (const itemHor of horarios) {
                      lista.push(itemHor);
                    }

                    lista.push({
                      id: horarios[horarios.length - 1]?.id + 1,
                      titulo: 'º Horário',
                      horaInicial: '13:00',
                      horaFinal: '23:00',
                      idProjetoAtividade:
                        ordemServicoAtividades?.length > 0 ? ordemServicoAtividades[0]?.id : 0,
                    });
                    setHorarios(lista);
                  }}
                >
                  <p className="adiciona-horario">Adicionar</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Materialize>
    </Container>
  );
}

export default CreateContent;
